import { action, observable } from 'mobx'
import { GenericStore } from './AdminStore'

const emptyOptions = () => ({
  cinemas: [],
  halls: [],
  movies: [],
  payment_methods: [],
})

export default class PaymentMethodWhitelistStore extends GenericStore {
  @observable options = emptyOptions()

  async fetchData(match) {
    const response = await super.fetchData(match)
    this.setOptions(response.data.options)
    return response
  }

  @action setOptions(options) {
    this.options = options || emptyOptions()
  }

  @action clearItems() {
    super.clearItems()
    this.options = emptyOptions()
  }
}
